export default __webpack_public_path__ + "ui/assets/img/info-red-32.svg";